var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmarttechnology1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1043_4886)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 64,
    height: 64,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3013 21.2L42.1013 18H34.6987L35.4987 21.2H41.3013ZM28 47.3333C28 48.0406 28.281 48.7189 28.781 49.219C29.2811 49.719 29.9594 50 30.6667 50H46.1333C46.4835 50 46.8303 49.931 47.1538 49.797C47.4774 49.663 47.7713 49.4666 48.019 49.219C48.2666 48.9713 48.463 48.6774 48.597 48.3538C48.731 48.0303 48.8 47.6835 48.8 47.3333V45.7333H28V47.3333ZM58.272 23.7493C58.5493 23.7493 58.816 23.6427 59.0293 23.44L59.5307 22.9387C59.7301 22.7392 59.8422 22.4687 59.8422 22.1867C59.8422 21.9046 59.7301 21.6341 59.5307 21.4347C59.3312 21.2352 59.0607 21.1232 58.7787 21.1232C58.4966 21.1232 58.2261 21.2352 58.0267 21.4347L57.5253 21.936C57.3765 22.085 57.2753 22.2748 57.2345 22.4814C57.1938 22.688 57.2154 22.9021 57.2965 23.0964C57.3777 23.2907 57.5147 23.4565 57.6903 23.5728C57.8659 23.689 58.0721 23.7505 58.2827 23.7493H58.272ZM53.2907 29.1893L56.7573 25.7227C56.8561 25.6239 56.9344 25.5067 56.9879 25.3776C57.0413 25.2486 57.0688 25.1103 57.0688 24.9707C57.0688 24.831 57.0413 24.6927 56.9879 24.5637C56.9344 24.4347 56.8561 24.3174 56.7573 24.2187C56.6586 24.1199 56.5413 24.0416 56.4123 23.9881C56.2833 23.9347 56.145 23.9072 56.0053 23.9072C55.8657 23.9072 55.7274 23.9347 55.5984 23.9881C55.4693 24.0416 55.3521 24.1199 55.2533 24.2187L52.096 27.376H50.9333V29.5093H52.5333C52.8213 29.5093 53.088 29.392 53.2907 29.2V29.1893ZM59.0293 44.56C58.8299 44.3606 58.5594 44.2485 58.2773 44.2485C57.9953 44.2485 57.7248 44.3606 57.5253 44.56C57.3259 44.7594 57.2138 45.0299 57.2138 45.312C57.2138 45.5941 57.3259 45.8646 57.5253 46.064L58.0267 46.5653C58.24 46.7787 58.5067 46.8747 58.784 46.8747C59.0613 46.8747 59.328 46.768 59.5413 46.5653C59.6402 46.4667 59.7187 46.3494 59.7722 46.2204C59.8257 46.0914 59.8533 45.953 59.8533 45.8133C59.8533 45.6736 59.8257 45.5353 59.7722 45.4063C59.7187 45.2772 59.6402 45.16 59.5413 45.0613L59.04 44.56H59.0293ZM53.2907 38.8107C53.1914 38.7113 53.0732 38.6328 52.9432 38.5797C52.8131 38.5266 52.6738 38.4999 52.5333 38.5013H50.9333V40.6347H52.096L55.2533 43.792C55.4667 44.0053 55.7333 44.1013 56.0107 44.1013C56.288 44.1013 56.5547 43.9947 56.768 43.792C56.8669 43.6933 56.9453 43.5761 56.9989 43.4471C57.0524 43.318 57.0799 43.1797 57.0799 43.04C57.0799 42.9003 57.0524 42.762 56.9989 42.6329C56.9453 42.5039 56.8669 42.3867 56.768 42.288L53.3013 38.8213L53.2907 38.8107ZM55.7333 34C55.7333 33.4133 55.2533 32.9333 54.6667 32.9333H50.9333V35.0667H54.6667C55.2533 35.0667 55.7333 34.5867 55.7333 34ZM58.9333 35.0667C59.52 35.0667 60 34.5867 60 34C60 33.4133 59.52 32.9333 58.9333 32.9333H57.8667C57.28 32.9333 56.8 33.4133 56.8 34C56.8 34.5867 57.28 35.0667 57.8667 35.0667H58.9333Z",
    fill: "url(#paint0_linear_1043_4886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1333 18H44.2987L43.168 22.5227C43.0507 22.992 42.624 23.3333 42.1333 23.3333H34.6667C34.176 23.3333 33.7493 23.0027 33.632 22.5227L32.5013 18H30.6667C29.9594 18 29.2811 18.281 28.781 18.781C28.281 19.2811 28 19.9594 28 20.6667V43.6H48.8V20.6667C48.8 20.3165 48.731 19.9697 48.597 19.6462C48.463 19.3226 48.2666 19.0287 48.0189 18.781C47.7713 18.5334 47.4774 18.337 47.1538 18.203C46.8303 18.069 46.4835 18 46.1333 18ZM41.2693 29.7333C41.2693 29.1467 41.7493 28.6667 42.336 28.6667C42.9227 28.6667 43.4027 29.1467 43.4027 29.7333V34.9387C43.4027 35.5253 42.9227 36.0053 42.336 36.0053C41.7493 36.0053 41.2693 35.5253 41.2693 34.9387V29.7333ZM37.3333 31.696C37.3333 31.1093 37.8133 30.6293 38.4 30.6293C38.9867 30.6293 39.4667 31.1093 39.4667 31.696V34.928C39.4667 35.5147 38.9867 35.9947 38.4 35.9947C37.8133 35.9947 37.3333 35.5147 37.3333 34.928V31.696ZM33.3973 33.6693C33.3973 33.0827 33.8773 32.6027 34.464 32.6027C35.0507 32.6027 35.5307 33.0827 35.5307 33.6693V34.9387C35.5307 35.5253 35.0507 36.0053 34.464 36.0053C33.8773 36.0053 33.3973 35.5253 33.3973 34.9387V33.6693ZM44.2987 39.3333H32.5013C31.9147 39.3333 31.4347 38.8533 31.4347 38.2667C31.4347 37.68 31.9147 37.2 32.5013 37.2H44.3093C44.896 37.2 45.376 37.68 45.376 38.2667C45.376 38.8533 44.896 39.3333 44.3093 39.3333H44.2987Z",
    fill: "url(#paint1_linear_1043_4886)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1043_4886",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1043_4886"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_4886"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1043_4886"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1043_4886",
    result: "effect2_dropShadow_1043_4886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1043_4886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_4886",
    x1: 28,
    y1: 34,
    x2: 60,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_4886",
    x1: 28,
    y1: 30.8,
    x2: 48.8,
    y2: 30.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmarttechnology1);
export default __webpack_public_path__ + "static/media/Smart technology1.6abbf6c9a372f2800bede82acb651156.svg";
export { ForwardRef as ReactComponent };